import { InjectionToken, Signal } from '@angular/core';

import { StaffRole, StaffUser } from './staff';

/**
 * Contrat d'authentification consommé par les gates RBAC de la lib.
 * L'application fournit l'implémentation (store NgRx signals) au bootstrap.
 */
export interface GisgoAuthContext {
  readonly user: Signal<StaffUser | null>;
  readonly role: Signal<StaffRole | null>;
}

export const GISGO_AUTH_CONTEXT = new InjectionToken<GisgoAuthContext>('GISGO_AUTH_CONTEXT');
